import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3718dbec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tacos"
};
const _hoisted_2 = {
  class: "tacos-graph"
};
const _hoisted_3 = {
  key: 1,
  class: "tacos-text gray"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tacos_graph = _resolveComponent("tacos-graph");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_tacos_graph, {
    values: $options.computedTacosData,
    selected_period: $props.selected_period,
    hovering_index: $props.hovering_index,
    workspace_id: $props.workspace_id,
    seller_id: $props.seller_id,
    hovering_workspace_id: $props.hovering_workspace_id,
    hovering_seller_id: $props.hovering_seller_id
  }, null, 8, ["values", "selected_period", "hovering_index", "workspace_id", "seller_id", "hovering_workspace_id", "hovering_seller_id"])]), $props.tacosData.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["tacos-text", {
      'zero-value': $options.lastestValue == 0,
      'non-zero-value': $options.lastestValue != 0
    }])
  }, _toDisplayString($options.lastestValue) + "% ", 3)) : (_openBlock(), _createElementBlock("div", _hoisted_3, "-"))]);
}